import type { PokerHomeGames } from '@ps/web-martech-cms-types';
import type {
  GetClubTournamentsStructuresRequest,
  GetClubTournamentsStructuresResponse
} from '@ps/web-shared-api-types/v1-preview/SwHomeGames';

import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';

import { PKR_LOADERS } from '../../constants';
import { ENDPOINTS } from '../../constants/endpoints';
import type { HomeGamesWidgetModel } from '../../model';

export const fetchTournamentStructures = async (
  { clubId }: { clubId: number },
  { request, dispatch, widget: { uid } }: WidgetEffectParams<PokerHomeGames>
) => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[uid];
  const loaderName = PKR_LOADERS.tournamentStructures;
  widgetDispatch.setLoading({ isLoading: true, loaderName });

  try {
    const {
      body: { success, tournamentStructures }
    } = await request<GetClubTournamentsStructuresResponse>({
      service: ENDPOINTS.tournamentStructures,
      http: true,
      body: { getClubTournStructures: { clubId } } as GetClubTournamentsStructuresRequest
    });

    if (success && tournamentStructures) {
      widgetDispatch.setTournamentStructures({
        response: tournamentStructures
      });
    }
  } catch {
    // TODO: Set error and display in modal if this request fails
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  }
};
